import { createSelector, createSlice } from "@reduxjs/toolkit";

const initialState = {
  urlSource: "",
};

export const sourceSlice = createSlice({
  name: "source",
  initialState,
  selectors: {
    GET_SOURCE_STATE: createSelector([(state) => state], (state) => {
      return {
        source: {
          urlSource: state?.urlSource,
        },
      };
    }),
  },
  reducers: {
    SET_SOURCE: (state, action) => {
      state.urlSource = action.payload;
    },
  },
});

export const { SET_SOURCE } = sourceSlice.actions;
export const { GET_SOURCE_STATE } = sourceSlice.selectors;
export default sourceSlice.reducer;
